import { React, useState, useEffect } from "react";
// import styled from "styled-components";
// Bar Styled Component
// const Bar = styled.div`
//   position: fixed;
//   height: 6px;
//   border-radius: 0px 2px 0px 0px;
//   background: linear-gradient(
//     90deg,
//     rgba(109, 227, 219, 1) 0%,
//     rgba(132, 115, 177, 1) 100%,
//     rgba(3, 9, 112, 1) 100%);
// `;
function ReadingBar() {
  //Width State
  const [width, setWidth] = useState(0);
  // scroll function
  const scrollHeight = () => {
    // var el = document.documentElement
    let el = document.querySelector('.l1-wrapper')


    // console.log(el)
      let ScrollTop = el.scrollTop || document.body.scrollTop;
      let ScrollHeight = el.scrollHeight || document.body.scrollHeight;

    //   var percent = (ScrollTop*1 / (ScrollHeight*1 - el.clientHeight)) * 100;
      var percent = (ScrollTop*1 / (el.clientHeight)) * 100;
      // store percentage in state
      
    // console.log(ScrollTop, ScrollHeight)
    // console.log("Alto", el.clientHeight)
    // console.log(percent)

    setWidth(percent);
  };

    //useEffect to control the component lifecycle
    useEffect(() => {
        window.addEventListener("scroll", scrollHeight, true);
        return () => window.removeEventListener("scroll", scrollHeight);
    });

  return <div style={{ width: width + "%" }}  className="readingBar"></div>;
}
export default ReadingBar;